import { commonErrors } from '@utils/error';
import { checkbox, requiredString } from '@utils/validation';
import { z } from 'zod';

export const dataConstants = {
	USE_INSURANCE: 'useInsurance',
};

export const schema = z.object({
	useInsurance: z.boolean({ required_error: commonErrors.selectionRequired }),
});
